module.exports = __webpack_public_path__ + "static_pc/img/12.dbb23af1.png";